/* global axios */
import ApiClient from './ApiClient';

class MultilatThemeAPI extends ApiClient {
  constructor() {
    super('inboxes', { accountScoped: true });
  }

  show(inboxId) {
    return axios.get(`${this.url}/${inboxId}/multilat_theme`);
  }

  update(inboxId, themeSettings) {
    return axios.patch(`${this.url}/${inboxId}/multilat_theme`, {
      theme_settings: themeSettings,
    });
  }

  uploadBackground(inboxId, file) {
    const formData = new FormData();
    formData.append('background', file);
    return axios.post(
      `${this.url}/${inboxId}/multilat_theme/background`,
      formData
    );
  }

  deleteBackground(inboxId) {
    return axios.delete(`${this.url}/${inboxId}/multilat_theme/background`);
  }
}

export default new MultilatThemeAPI();
